import '.ak{display:inline-flex;}.ssr-plugin'
import '.a1{justify-content:center;}.ssr-plugin'
import '.aa{align-items:center;}.ssr-plugin'
import '.bj{cursor:pointer;}.ssr-plugin'
import { styled, type Style } from 'inlines'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { type IconDefinition } from '@fortawesome/pro-solid-svg-icons'

export type IconButtonProps = {
  variant?: Variant
  size?: Size
  shape?: Shape
  icon: IconDefinition
  disabled?: boolean
  style?: Style
  onClick: () => void
}

type Size = 'medium' | 'small'
type Variant = 'primary' | 'secondary' | 'transparent'
type Shape = 'square' | 'circle'

const sizeStyle: Record<Size, Style> = {
  medium: {
    width: '3rem',
    height: '3rem',
    padding: '0.625rem',
    aspectRatio: '1/1',
    fontSize: '1.125rem',
  },
  small: {
    width: '2rem',
    height: '2rem',
    padding: '0.25rem',
    aspectRatio: '1/1',
    fontSize: '0.875rem',
  },
}

const shapeStyle: Record<Shape, Style> = {
  square: { borderRadius: '0.625rem' },
  circle: { borderRadius: '50%' },
}

const variantStyle: Record<Variant, Style> = {
  primary: {
    color: 'var(--palette-white)',
    background: 'var(--brand-primary)',
    border: '2px solid var(--brand-primary)',
    '&:hover': {
      background: 'var(--palette-red-600)',
      border: '2px solid var(--palette-red-600)',
    },
    '&:active': {
      background: 'var(--palette-red-600)',
      border: '2px solid var(--palette-red-600)',
    },
    '&:disabled': {
      background: 'var(--palette-red-200)',
      border: '2px solid var(--palette-red-200)',
    },
  },
  secondary: {
    color: 'var(--brand-secondary)',
    background: 'var(--gray-100)',
    border: '2px solid var(--gray-100)',
    '&:hover': {
      background: 'var(--palette-blue-50)',
      border: '2px solid var(--palette-blue-50)',
    },
    '&:active': {
      background: 'var(--palette-blue-50)',
      border: '2px solid var(--palette-blue-50)',
    },
    '&:disabled': {
      color: 'var(--palette-blue-100)',
    },
  },
  transparent: {
    color: 'var(--brand-secondary)',
    background: 'transparent',
    border: '2px solid var(--brand-secondary)',
    '&:active': {
      background: 'var(--palette-blue-50)',
      border: '2px solid var(--palette-blue-50)',
    },
    '&:disabled': {
      color: 'var(--palette-blue-100)',
    },
  },
}

export const IconButton = ({
  variant = 'primary',
  size = 'medium',
  shape = 'square',
  icon,
  disabled = false,
  style,
  onClick,
}: IconButtonProps) => {
  return (
    <styled.button className="ak a1 aa bj"
      disabled={disabled}
      onClick={onClick}
      style={{
        '&:hover:disabled': {
          cursor: 'not-allowed',
        },
        ...variantStyle[variant],
        ...sizeStyle[size],
        ...shapeStyle[shape],
        ...style,
      }}
    >
      <FontAwesomeIcon icon={icon} style={{ width: '100%', height: '100%' }} />
    </styled.button>
  )
}
